<div class="view view-content elements">
  <mat-card>
    <mat-card-content>
      <sg2-elements-table></sg2-elements-table>
    </mat-card-content>
  </mat-card>
</div>
